import React from 'react';
import styled from 'styled-components';
import media from 'styled-media-query';
import Logo from './Logo';
import Navbar from './Navbar';
import Drawer from './Drawer';

const Content = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	margin-top: 10px;
	${media.lessThan('medium')`
		grid-template-columns: 20fr 1fr;
	`}
`;

const Header = () => {
	return(
		<header>
			<Content>
				<Logo />
				<Navbar />
				<Drawer />
			</Content>
		</header>
	);
}

export default Header;